<template>
	<div id="app" class="app">
		<bv-header/>
		<router-view class="content"/>
		<bv-footer/>
	</div>
</template>

<script>
import BvHeader from "./components/BvHeader.vue";
import BvFooter from "./components/BvFooter.vue";
export default {
	name: "App",
	components: {
		BvHeader,
		BvFooter,
	},
};
</script>

<style scoped>
.app {
	display: flex;
	flex-direction: column;
}
.content {
	flex: 1;
}

</style>
